<template>
  <section>
    <h3 class="title">Common</h3>
    <section>
        <div class="field">
          <b-checkbox v-model="settings.enable_outstanding_notifications">
            Enable outstanding docs notifications?
          </b-checkbox>
        </div>

        <b-field label="SMTP server">
          <b-input type="text" v-model="settings.mail_server"/>
        </b-field>

        <b-field label="Mail address to send notifications from">
          <b-input type="text" v-model="settings.mail_address_from"/>
        </b-field>

        <b-field label="WFM API URL">
          <b-input type="text" v-model="settings.wfm_api_url"/>
        </b-field>

        <b-field label="WFM API Key">
          <b-input type="password" v-model="settings.wfm_api_key"/>
        </b-field>

        <b-field label="WFM Account Key">
          <b-input type="password" v-model="settings.wfm_api_account_key"/>
        </b-field>

        <b-field label="WFM Upload Email">
          <b-input type="text" v-model="settings.wfm_upload_email"/>
        </b-field>

      <div class="buttons is-right">
        <button class="button is-primary" @click.prevent="saveSettings">Save</button>
      </div>
    </section>
  </section>
</template>

<script>

export default {
  name: 'CommonSettings',
  data () {
    return {
      settings: {}
    }
  },
  created () {
    this.getSettings()
  },
  methods: {
    getSettings () {
      this.axios.get('/settings')
        .then(response => {
          this.settings = response.data
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: 'Something went wrong while getting a settings',
            type: 'is-danger'
          })
        })
    },
    saveSettings () {
      this.axios.put('/settings', {
        ...this.settings
      })
        .then(response => {
          this.settings = response.data
          this.$toast.open({
            message: 'Saved',
            type: 'is-info'
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: 'Something went wrong while getting a settings',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>
